
export default {
  // eslint-disable-next-line
  name: "Footer",
};
